// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '',
};

// ----------------------------------------------------------------------

export const paths = {
  // AUTH
  auth: {
    callback: `${ROOTS.AUTH}/callback`,
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    customers: `${ROOTS.DASHBOARD}/customers`,
    customerProfile: (id: string) => `${ROOTS.DASHBOARD}/customer/${id}`,
    customerPauseControl: (customerId: string) =>
      `${ROOTS.DASHBOARD}/customer/${customerId}/manage-pause`,
    invoices: `${ROOTS.DASHBOARD}/invoices`,
    invoiceOverview: (id: string, customerId: string) =>
      `${ROOTS.DASHBOARD}/invoice/${id}?customerId=${customerId}`,
    payments: {
      paymentsManagement: `${ROOTS.DASHBOARD}/payments`,
      directDebitSubscriptions: `${ROOTS.DASHBOARD}/payments/direct-debit-subscriptions`,
    },
    paymentMatching: (id: string) => `${ROOTS.DASHBOARD}/payments/${id}/match`,
    communication: {
      unassignedEmails: `${ROOTS.DASHBOARD}/communication/unassigned-emails`,
    },
    // imports: `${ROOTS.DASHBOARD}/imports`,
    // failures: `${ROOTS.DASHBOARD}/failures`,
    analytics: `${ROOTS.DASHBOARD}/analytics`,
    reports: `${ROOTS.DASHBOARD}/reports`,
    users: `${ROOTS.DASHBOARD}/users`,
    // profile: `${ROOTS.DASHBOARD}/profile`,
    // security: `${ROOTS.DASHBOARD}/security`,
    // settings: `${ROOTS.DASHBOARD}/settings`,
    clients: {
      client: `${ROOTS.DASHBOARD}/clients`,
      serviceLine: `${ROOTS.DASHBOARD}/service-line`,
    },
    serviceLines: (clientId: string) => `${ROOTS.DASHBOARD}/service-line?clientId=${clientId}`,
    serviceLineOverview: (id: string, clientId: string) =>
      `${ROOTS.DASHBOARD}/service-line/${id}?clientId=${clientId}`,
    webhooks: {
      subscriptions: `${ROOTS.DASHBOARD}/webhooks`,
      history: `${ROOTS.DASHBOARD}/webhooks/history`,
    },
    settings: {
      oidcClient: `${ROOTS.DASHBOARD}/settings/oidc-client`,
    },
  },
};
